import { Card } from '@seiue/ui'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
  margin: 16px 10%;
`

export const LeftCard = styled(Card)`
  width: 55vw;
  min-height: 30vw;
  border-radius: 8px;
`
export const Blank = styled.div`
  width: 12px;
  height: 12px;
`
